module.exports = (__webpack_require__(24))(8);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/babel-runtime/helpers/inherits.js from dll-reference lib_core
// module id = 149
// module chunks = 106